module.exports = __webpack_public_path__ + "img/mobile.ef6d4d71.png";